import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faCoins,
  faBoxOpen,
  faHeart,
  faCreditCard,
  faCalendarAlt,
  faShoppingBag,
  faUserCircle
} from '@fortawesome/free-solid-svg-icons';

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const menuItems = [
    { name: "Overview", path: "/account/dashboard", icon: faChartLine },
    { name: "Afric-Points", path: "/account/points", icon: faCoins },
    { name: "Orders", path: "/account/orders", icon: faBoxOpen },
    { name: "Favorites", path: "/account/favourite", icon: faHeart },
    { name: "Payment", path: "/account/payment", icon: faCreditCard },
    { name: "Subscription", path: "/account/subscription", icon: faCalendarAlt },
  ];

  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [isUser, setIsUser] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem("AficFreshuserDetails");
    if (user) {
      const parsedUser = JSON.parse(user);
      setIsUser(parsedUser);
    }
  }, []);

  return (
    <>
      {/* Toggle Button with Hamburger Icon */}
      <button
        onClick={toggleSidebar}
        className="sm:hidden fixed top-8 left-4 z-50 p-2 bg-[#007D44] text-white rounded-md shadow-lg focus:outline-none"
      >
        <div className="space-y-1">
          <span
            className={`block w-6 h-0.5 bg-white transform transition-transform ${
              isSidebarOpen ? "rotate-45 translate-y-1.5" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transition-opacity ${
              isSidebarOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-white transform transition-transform ${
              isSidebarOpen ? "-rotate-45 -translate-y-1.5" : ""
            }`}
          ></span>
        </div>
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed max-sm:mt-8 top-0 left-0 h-full bg-white border-r w-64 z-40 transform ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out sm:translate-x-0 sm:static`}
      >
        {/* User Info Section */}
        <div className="hidden max-sm:block border-b pb-4">
          <div className="flex items-center p-4">
            <FontAwesomeIcon 
              icon={faUserCircle} 
              className="text-3xl text-gray-400 mr-3" 
            />
            <div>
              <h2 className="text-sm font-semibold">
                {isUser ? `${isUser.firstName} ${isUser.lastName}` : "Guest User"}
              </h2>
              <p className="text-xs text-gray-500">
                {isUser ? `${isUser.email}` : "Sign in for full access"}
              </p>
            </div>
          </div>
          <Link 
            to="/" 
            className="flex items-center p-1 pl-4 w-full pt-2 pb-2 text-base cursor-pointer hover:bg-gray-100"
          >
            <FontAwesomeIcon 
              icon={faShoppingBag} 
              className="text-[#007D44] mr-3 w-5" 
            />
            <span className="text-[#007D44]">Shop</span>
          </Link> 
        </div> 

        {/* Main Menu */}
        <h2 className="text-lg font-bold p-4 max-sm:mt-2">Account</h2>
        <ul className="space-y-1">
          {menuItems.map((item, index) => ( 
            <li
              key={index}
              className={`flex items-center p-1 pl-4 pt-2 pb-2 text-base cursor-pointer border-l-4 ${
                location.pathname === item.path
                  ? "bg-gray-100 border-[#259663] text-[#007D44]"
                  : "border-transparent hover:bg-gray-100 hover:border-[#F2E7DB]"
              }`}
            >
              <FontAwesomeIcon 
                icon={item.icon} 
                className={`mr-3 w-5 ${
                  location.pathname === item.path 
                    ? "text-[#259663]" 
                    : "text-gray-500"
                }`} 
              />
              <Link to={item.path} className="flex-1">
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      {/* Overlay */}
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
        ></div>
      )}
    </>
  );
};

export default Sidebar;